import { CreatePortalModal } from '../CreatePortalModal';
import { EditPortalModal } from '../EditPortalModal';
import { usePortalList } from './hooks';
import { convertToPresentationProps } from './logics';
import { PortalListPresentation } from './presentations';
import { PortalListEmptyPresentation } from './presentations/Empty';

export const PortalList: React.FC = () => {
  const {
    state: { data, selectedPortal, isOpenEditModal, isOpenCreateModal, tooltipId },
    actions: {
      handleReOrder,
      handleShowTooltip,
      handleHideTooltip,
      handleEditPortal,
      handleDeletePortal,
      handleCloseEditModal,
      handleOpenCreateModal,
      handleCloseCreateModal,
      handleRefreshPortalList,
    },
  } = usePortalList();

  if (data.client_portal_items.length === 0) {
    return (
      <>
        <PortalListEmptyPresentation handleOpenCreateModal={handleOpenCreateModal} />
        <CreatePortalModal isOpen={isOpenCreateModal} onClose={handleCloseCreateModal} />
      </>
    );
  }

  const { portalItems, lastSortOrder } = convertToPresentationProps({
    data: data.client_portal_items,
  });

  return (
    <>
      <PortalListPresentation
        portalItems={portalItems}
        onReOrder={handleReOrder}
        handleEditPortal={handleEditPortal}
        handleDeletePortal={handleDeletePortal}
        handleOpenCreateModal={handleOpenCreateModal}
        showTooltip={handleShowTooltip}
        hideTooltip={handleHideTooltip}
        tooltipId={tooltipId}
      />
      {isOpenEditModal && selectedPortal && (
        <EditPortalModal
          portalId={selectedPortal.id.toString()}
          isOpen={isOpenEditModal}
          defaultValues={{
            title: selectedPortal.title,
            icon_name: selectedPortal.iconName,
            url: selectedPortal.linkUrl || '',
            item_type: selectedPortal.itemType,
            sort_order: selectedPortal.sortOrder,
          }}
          defaultFileUrl={selectedPortal.fileUrl}
          onClose={handleCloseEditModal}
          onSuccess={handleRefreshPortalList}
        />
      )}
      {isOpenCreateModal && (
        <CreatePortalModal isOpen lastSortOrder={lastSortOrder} onClose={handleCloseCreateModal} />
      )}
    </>
  );
};
